import React from 'react';
import PropTypes from 'prop-types';
import Thumbnail from 'components/media-publications/Thumbnail';
import { trackDownload } from 'utils/general';
function SingleMediaContent(props) {
  const { documents = [], images = [], title = '', className = '' } = props;
  return (
    <div className={`${className} section-category`}>
      <div className="row">
        <div className="column small-12">
          <h4 className="section-category-title">{title}</h4>
          <div className="downloads section-category-media-files">
              {documents.map((doc, i) => (
                <a
                  key={i}
                  onClick={trackDownload}
                  target="-blank"
                  href={config.apiHost + doc.document}
                  className="download"
                  download
                >
                  <svg className="c-icon -dark">
                    <use xlinkHref="#icon-download"></use>
                  </svg>
                  {doc.title && doc.title ? doc.title : 'Download'}
                </a>
              ))}
          </div>

        </div>
      </div>
      <div className="row images">
        <div className="column small-12 ">
          <div className="c-images -media-images-row row">
            {images.map((img, i) => (
              <div className="small-12 medium-4 image-wrapper" key={i}>
                <Thumbnail
                  className={'image-wrapper'}
                  data={{
                    title: img.title,
                    src: img.image,
                    thumbnail: img.image,
                    hoverData: (
                      <span className="main-title">
                        <svg className="icon">
                          <use xlinkHref="#icon-download"></use>
                        </svg>
                        Open
                      </span>
                    )
                  }}
                  type="image"
                  options={{ isDownload: true, showTitle: true }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
SingleMediaContent.propTypes = {
  images: PropTypes.array,
  documents: PropTypes.array,
  title: PropTypes.string,
  className: PropTypes.string
};

SingleMediaContent.defaultProps = {
  images: [],
  documents: [],
  title: ''
};

export default SingleMediaContent;



// WEBPACK FOOTER //
// ./app/components/media-publications/SingleMediaContent.jsx